var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rango_temporal == 'rango-de-fechas')?_c('div',{staticClass:"chart-card"},[_vm._m(0),_c('chart')],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h4',[_vm._v("Gastos por mes")])])
}]

export { render, staticRenderFns }